import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';

import './i18n';
import './styles/styles.scss';

import { getBrandingForProduct } from './api/idm';
import App from './components/App';

(async () => {
  Sentry.init({
    dsn: 'https://3a12d54954184fb8a12404f9f40239ee@sentry.io/1461111',
    environment: process.env.REACT_APP_ENV,
  });

  const branding = await getBrandingForProduct();

  ReactDOM.render(<App branding={branding} />, document.getElementById('root'));
})();
